import { render, staticRenderFns } from "./RemovedUsers.vue?vue&type=template&id=07e5ce37&"
import script from "./RemovedUsers.vue?vue&type=script&lang=js&"
export * from "./RemovedUsers.vue?vue&type=script&lang=js&"
import style0 from "./RemovedUsers.vue?vue&type=style&index=0&id=07e5ce37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports